<template>
  <div class="d-flex justify-content-end mx-5 mb-5">
    <h-b-action
        :text="textReturn"
        :positive="false"
        @click.native="clickReturn"
        v-if="loadedPost"
    >
    </h-b-action>
    <h-b-action
        :text="textNext"
        :positive="true"
        @click.native="clickNext"
        class="ml-5"
        v-if="loadedPost"
    >
    </h-b-action>
    <h-e-spinner class="d-flex justify-content-end m-0 p-0" size="sm" v-else></h-e-spinner>
  </div>
</template>

<script>
export default {
  name: "form-confirm",

  props : {
    loadedPost : {
      type: Boolean,
      default: true
    },
    textNext: {
      type: String,
      default: 'Suivant'
    },
    textReturn: {
      type: String,
      default: 'Retour'
    }
  },

  methods : {
    clickReturn(){
      this.$emit("clickReturn")
    },

    clickNext(){
      this.$emit("clickNext") ;
    }
  }
}
</script>

<style scoped>

</style>